import * as actionTypes from '../actions/actionTypes'

const initialState = {
  pagination: { total: 0, to: 0, lastPage: 1, from: 0, currentPage: 1, perPage: 10 },
  records: [],
  loading: false,
  success: false,
  filterLoading: false,
  selectedRecord: null,
  filterPasswordPolicy: []
}

const fetchPasswordPolicyStart = (state, action) => {
  return { ...state, loading: true }
}

const fetchPasswordPolicySuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    pagination: action.pagination,
    records: action.records
  }
}

const fetchPasswordPolicyFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    errorMessage: action.errorMessage
  }
}

const fetchPasswordPolicyByIdSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    selectedRecord: action.recordData
  }
}

const clearSelectedPasswordPolicyRecord = (state, action) => {
  return {
    ...state,
    selectedRecord: null,
    success: false
  }
}

const createPasswordPolicyStart = (state, action) => {
  return { ...state, loading: true }
}

const createPasswordPolicySuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    success: true
  }
}

const createPasswordPolicyFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    success: false
  }
}

const updatePasswordPolicyStart = (state, action) => {
  return { ...state, loading: true }
}

const updatePasswordPolicySuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    success: true
  }
}

const updatePasswordPolicyFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    success: false
  }
}

const deletePasswordPolicyStart = (state, action) => {
  return { ...state, loading: true }
}

const deletePasswordPolicySuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    success: true
  }
}

const deletePasswordPolicyFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    success: false
  }
}

const fetchMinimumAgeStart = (state, action) => {
  return { ...state, loading: true }
}

const fetchMinimumAgeSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    minimumAge: action.data
  }
}

const fetchMinimumAgeFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    message: action.errorMessage
  }
}

const fetchResetTicketMaxAgeStart = (state, action) => {
  return { ...state, loading: true }
}

const fetchResetTicketMaxAgeSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    resetTicketMaxAge: action.data
  }
}

const fetchResetTicketMaxAgeFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    message: action.errorMessage
  }
}

const fetchHistoryCountStart = (state, action) => {
  return { ...state, loading: true }
}

const fetchHistoryCountSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    historyCount: action.data
  }
}

const fetchHistoryCountFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    message: action.errorMessage
  }
}

const fetchMaximumAgeStart = (state, action) => {
  return { ...state, loading: true }
}

const fetchMaximumAgeSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    maximumAge: action.data
  }
}

const fetchMaximumAgeFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    message: action.errorMessage
  }
}

const fetchWarningTimeStart = (state, action) => {
  return { ...state, loading: true }
}

const fetchWarningTimeSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    warningTime: action.data
  }
}

const fetchWarningTimeFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    message: action.errorMessage
  }
}

const fetchResetFailureCountStart = (state, action) => {
  return { ...state, loading: true }
}

const fetchResetFailureCountSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    resetFailureCount: action.data
  }
}

const fetchResetFailureCountFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    message: action.errorMessage
  }
}

const fetchLockoutDurationStart = (state, action) => {
  return { ...state, loading: true }
}

const fetchLockoutDurationSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    lockoutDuration: action.data
  }
}

const fetchLockoutDurationFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    message: action.errorMessage
  }
}

const fetchPasswordPolicyFilterPasswordPolicyStart = (state, action) => {
  return { ...state, filterLoading: true }
}

const fetchPasswordPolicyFilterPasswordPolicySuccess = (state, action) => {
  return {
    ...state,
    filterLoading: false,
    filterPasswordPolicy: action.data
  }
}

const fetchPasswordPolicyFilterPasswordPolicyFailed = (state, action) => {
  return {
    ...state,
    filterLoading: false,
    message: action.errorMessage
  }
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_PASSWORD_POLICY_START:
      return fetchPasswordPolicyStart(state, action)
    case actionTypes.FETCH_PASSWORD_POLICY_SUCCESS:
      return fetchPasswordPolicySuccess(state, action)
    case actionTypes.FETCH_PASSWORD_POLICY_BY_ID_SUCCESS:
      return fetchPasswordPolicyByIdSuccess(state, action)
    case actionTypes.FETCH_PASSWORD_POLICY_FAILED:
      return fetchPasswordPolicyFailed(state, action)
    case actionTypes.CLEAR_SELECTED_PASSWORD_POLICY_RECORD:
      return clearSelectedPasswordPolicyRecord(state, action)
    case actionTypes.CREATE_PASSWORD_POLICY_START:
      return createPasswordPolicyStart(state, action)
    case actionTypes.CREATE_PASSWORD_POLICY_SUCCESS:
      return createPasswordPolicySuccess(state, action)
    case actionTypes.CREATE_PASSWORD_POLICY_FAILED:
      return createPasswordPolicyFailed(state, action)
    case actionTypes.UPDATE_PASSWORD_POLICY_START:
      return updatePasswordPolicyStart(state, action)
    case actionTypes.UPDATE_PASSWORD_POLICY_SUCCESS:
      return updatePasswordPolicySuccess(state, action)
    case actionTypes.UPDATE_PASSWORD_POLICY_FAILED:
      return updatePasswordPolicyFailed(state, action)
    case actionTypes.DELETE_PASSWORD_POLICY_START:
      return deletePasswordPolicyStart(state, action)
    case actionTypes.DELETE_PASSWORD_POLICY_SUCCESS:
      return deletePasswordPolicySuccess(state, action)
    case actionTypes.DELETE_PASSWORD_POLICY_FAILED:
      return deletePasswordPolicyFailed(state, action)
    case actionTypes.FETCH_PASSWORD_POLICY_MINIMUM_AGE_OPTIONS_START:
      return fetchMinimumAgeStart(state, action)
    case actionTypes.FETCH_PASSWORD_POLICY_MINIMUM_AGE_OPTIONS_SUCCESS:
      return fetchMinimumAgeSuccess(state, action)
    case actionTypes.FETCH_PASSWORD_POLICY_MINIMUM_AGE_OPTIONS_FAILED:
      return fetchMinimumAgeFailed(state, action)
    case actionTypes.FETCH_PASSWORD_POLICY_RESET_TICKET_MAX_AGE_OPTIONS_START:
      return fetchResetTicketMaxAgeStart(state, action)
    case actionTypes.FETCH_PASSWORD_POLICY_RESET_TICKET_MAX_AGE_OPTIONS_SUCCESS:
      return fetchResetTicketMaxAgeSuccess(state, action)
    case actionTypes.FETCH_PASSWORD_POLICY_RESET_TICKET_MAX_AGE_OPTIONS_FAILED:
      return fetchResetTicketMaxAgeFailed(state, action)
    case actionTypes.FETCH_PASSWORD_POLICY_HISTORY_COUNT_OPTIONS_START:
      return fetchHistoryCountStart(state, action)
    case actionTypes.FETCH_PASSWORD_POLICY_HISTORY_COUNT_OPTIONS_SUCCESS:
      return fetchHistoryCountSuccess(state, action)
    case actionTypes.FETCH_PASSWORD_POLICY_HISTORY_COUNT_OPTIONS_FAILED:
      return fetchHistoryCountFailed(state, action)
    case actionTypes.FETCH_PASSWORD_POLICY_MAXIMUM_AGE_OPTIONS_START:
      return fetchMaximumAgeStart(state, action)
    case actionTypes.FETCH_PASSWORD_POLICY_MAXIMUM_AGE_OPTIONS_SUCCESS:
      return fetchMaximumAgeSuccess(state, action)
    case actionTypes.FETCH_PASSWORD_POLICY_MAXIMUM_AGE_OPTIONS_FAILED:
      return fetchMaximumAgeFailed(state, action)
    case actionTypes.FETCH_PASSWORD_POLICY_WARNING_TIME_OPTIONS_START:
      return fetchWarningTimeStart(state, action)
    case actionTypes.FETCH_PASSWORD_POLICY_WARNING_TIME_OPTIONS_SUCCESS:
      return fetchWarningTimeSuccess(state, action)
    case actionTypes.FETCH_PASSWORD_POLICY_WARNING_TIME_OPTIONS_FAILED:
      return fetchWarningTimeFailed(state, action)
    case actionTypes.FETCH_PASSWORD_POLICY_RESET_FAILURE_COUNT_OPTIONS_START:
      return fetchResetFailureCountStart(state, action)
    case actionTypes.FETCH_PASSWORD_POLICY_RESET_FAILURE_COUNT_OPTIONS_SUCCESS:
      return fetchResetFailureCountSuccess(state, action)
    case actionTypes.FETCH_PASSWORD_POLICY_RESET_FAILURE_COUNT_OPTIONS_FAILED:
      return fetchResetFailureCountFailed(state, action)
    case actionTypes.FETCH_PASSWORD_POLICY_LOCKOUT_DURATION_OPTIONS_START:
      return fetchLockoutDurationStart(state, action)
    case actionTypes.FETCH_PASSWORD_POLICY_LOCKOUT_DURATION_OPTIONS_SUCCESS:
      return fetchLockoutDurationSuccess(state, action)
    case actionTypes.FETCH_PASSWORD_POLICY_LOCKOUT_DURATION_OPTIONS_FAILED:
      return fetchLockoutDurationFailed(state, action)
    case actionTypes.FETCH_PASSWORD_POLICY_FILTER_PASSWORD_POLICY_START:
      return fetchPasswordPolicyFilterPasswordPolicyStart(state, action)
    case actionTypes.FETCH_PASSWORD_POLICY_FILTER_PASSWORD_POLICY_SUCCESS:
      return fetchPasswordPolicyFilterPasswordPolicySuccess(state, action)
    case actionTypes.FETCH_PASSWORD_POLICY_FILTER_PASSWORD_POLICY_FAILED:
      return fetchPasswordPolicyFilterPasswordPolicyFailed(state, action)
    case actionTypes.SIGNOUT_SUCCESS:
    case actionTypes.SIGNOUT_FAILED:
      return { ...initialState }
    default:
      return state
  }
}

export default reducer
